import { useMutation } from 'react-query';

import * as API from './api';

interface HandleReturn {
  onSuccess?: () => void;
  onError?: () => void;
}

interface CustomMutation<Query, Response> {
  key: string;
  request: (params: Query) => Promise<Response>;
  handleReturn?: HandleReturn;
}

function useCustomMutation<Query, Response>({
  handleReturn,
  key,
  request,
}: CustomMutation<Query, Response>) {
  return useMutation([key], (params: Query) => request(params), {
    onSuccess: () => {
      if (handleReturn?.onSuccess) handleReturn?.onSuccess();
    },
    onError: () => {
      if (handleReturn?.onError) handleReturn?.onError();
    },
  });
}

export function useGetMessageById(handleReturn?: HandleReturn) {
  return useCustomMutation({
    key: 'getMessageById',
    request: API.getMessageById,
    handleReturn,
  });
}

export function useGetMessagesHistory(handleReturn?: HandleReturn) {
  return useCustomMutation({
    key: 'getMessagesHistory',
    request: API.getMessagesHistory,
    handleReturn,
  });
}

export function useResetChat(handleReturn?: HandleReturn) {
  return useCustomMutation({
    key: 'resetChat',
    request: API.resetChat,
    handleReturn,
  });
}

export function useSendMessage(handleReturn?: HandleReturn) {
  return useCustomMutation({
    key: 'sendMessage',
    request: API.sendMessage,
    handleReturn,
  });
}

export function useGetMessageSuggestions(handleReturn?: HandleReturn) {
  return useCustomMutation({
    key: 'getMessageSuggestions',
    request: API.getMessageSuggestions,
    handleReturn,
  });
}
